import { render, staticRenderFns } from "./CookieControl.vue?vue&type=template&id=0dea8e94&scoped=true"
import script from "./CookieControl.vue?vue&type=script&lang=js"
export * from "./CookieControl.vue?vue&type=script&lang=js"
import style0 from "./CookieControl.vue?vue&type=style&index=0&id=0dea8e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dea8e94",
  null
  
)

export default component.exports